import React from "react";
import { Space, Row, Col, Tooltip, Image } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
// import PythonReportStore from "../store/PythonReportStore";
import ListTable from "./ListTable";
import config from "../config";
import withRouter from "../withRouter";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";

class PythonReportList extends React.Component {
  constructor(props) {
    super(props);
    // this.pythonReportStore = new PythonReportStore();
    this.handleTableChange = this.handleTableChange.bind(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadData: 1,
    };
  }
  async componentDidMount() {
    await this.handleSearch();

    this.columns = [
      {
        title: this.context.translate("_REPORT_NAME_"),
        dataIndex: "reportName",
        width: 30,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: this.context.translate("_STATUS_"),
        dataIndex: "status",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (val) => {
          if (val == 1) {
            return "Completed";
          } else {
            return "Pending";
          }
        },
      },
      {
        title: this.context.translate("_REPORT_LINK_"),
        dataIndex: "filename",
        width: 30,
        ellipsis: {
          showTitle: true,
        },
        render: (url, record) => {
          if (record.status == 1) {
            return (
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "blue" }}
                onClick={(e) => {
                  e.preventDefault();
                  window.open(config.pythonReportlUrl + url, "_blank");
                }}
              >
                {config.pythonReportlUrl + url}
              </a>
            );
          } else {
            return "";
          }
        },
      },
      {
        title: this.context.translate("_DATE_"),
        dataIndex: "createDate",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
    ];
  }
  async handleTableChange(pagination, filters, sorter) {
    // console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  refreshList = async () => {
    this.setState({ loading: true });
    await this.pythonReportStore.loadData({
      offset: 0,
      limit: 50,
    });
    this.setState({ loading: false, currentPage: 1 });
  };

  async handleSearch() {
    this.setState({ loading: true });
    await this.pythonReportStore.loadData();
    await this.setState({ loadData: 1, loading: false });
  }
  render() {
    console.log("pythonReportList", this.pythonReportStore?.pythonReportList);
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_PYTHON_REPORT_LIST_")}
              </div>
            </Col>
          </Row>
        </div> */}

        <div className="listHeader">
          <Row className="listInputRow">
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={24}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "20px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.pythonReportStore?.total}
            columns={this.columns}
            dataSource={this.pythonReportStore?.pythonReportList}
            loading={this.pythonReportStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>
      </>
    );
  }
}
PythonReportList.contextType = StoreContext;
export default observer(withRouter(PythonReportList));
